/** @format */

import React, {
  FunctionComponent,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect
} from 'react'
import { Input, _$, Form, FormItem, Icon } from 'kpc-react'
import _ from 'lodash'
import styled from 'styled-components'

interface OwnProps {
  defaultValue?: any
  className?: string
  ref?: any
}

const AlarmCallBack: FunctionComponent<OwnProps> = forwardRef(
  ({ defaultValue, className }, ref) => {
    const [callbackUrl, setUrl] = useState<string[]>([])
    const urlForm = useRef(null)
    useImperativeHandle(ref, () => ({
      getUrl: async () => {
        const urlData = await urlForm.current?.validate()
        if (urlData) {
          return callbackUrl
        } else {
          return false
        }
      }
    }))
    const addUrl = async () => {
      const formItem = urlForm.current
      const validateData = await formItem.validate()
      if (validateData) {
        const url = _.cloneDeep(callbackUrl) || []
        url.push('')
        setUrl(url)
      }
    }

    const delItem = index => {
      const url = _.cloneDeep(callbackUrl)
      const filterUrl = url.filter((el, i) => i !== index)
      setUrl(filterUrl)
    }

    const setValue = (index, value) => {
      const url = _.cloneDeep(callbackUrl)
      url[index] = value
      setUrl(url)
    }

    useEffect(() => {
      if (defaultValue) {
        const callbackUrl = Array.isArray(defaultValue) ? defaultValue : defaultValue.split(',')
        setUrl(callbackUrl)
      }
    }, [defaultValue])

    return (
      <div className={className}>
        {/* */}
        <Form labelWidth={0} ref={form => (urlForm.current = form)}>
          {Array.isArray(callbackUrl)
            ? callbackUrl.map((item, index) => (
                <FormItem
                  key={item + index}
                  rules={{
                    required: true,
                    isWebAddress: true,
                    unique: value => {
                      const validate = callbackUrl.every((item, i) => index === i || value !== item)
                      if (!validate) {
                        return _$('告警回调不能重复')
                      } else if (value.indexOf(',') >= 0) {
                        return _$('告警回调不支持英文逗号')
                      } else {
                        return true
                      }
                    }
                  }}
                  value={item}
                  messages={{
                    required: _$('请输入告警回调')
                  }}
                >
                  <Input
                    style={{ width: '530px' }}
                    key={item + index}
                    value={item}
                    onBlur={e => setValue(index, e.target.value)}
                    placeholder={_$(
                      '填写公网可访问到的URL作为回调接口地址,例如:https://console.ksyun.com:8080/callback'
                    )}
                  />
                  <a style={{ marginLeft: '8px' }} onClick={() => delItem(index)}>
                    {_$('删除')}
                  </a>
                </FormItem>
              ))
            : null}
        </Form>
        {callbackUrl?.length < 5 && (
          <p className="add">
            <a onClick={() => addUrl()}>
              <Icon className="ion-plus-round"></Icon>
              {_$('添加回调')}
            </a>
          </p>
        )}
      </div>
    )
  }
)

export default styled(AlarmCallBack)`
  .k-form-item {
    margin: 0;
    padding-bottom: 18px;
    &:last-child {
      padding-bottom: 12px;
    }
    .k-label {
      padding: 0;
    }
  }
  .add {
    line-height: 32px;
    .ion-plus-round {
      margin-right: 4px;
      font-size: 14px;
    }
  }
`
